import Axios from "axios";

import store from "../store";

import * as ACTIONS from "../store/actions";

import cm from "../store/modules/CommonFunction";

// var url = "http://localhost:3568";
var url = "https://alinmauatapi.fajrbahrain.com";
// var url = "https://alinmaapi.fajrbahrain.com";
const Api = Axios.create({
  //baseURL: "http://192.168.1.147/gfhapi/api/" //working //Local Nw UAT
  //baseURL: "http://localhost:3568/api/", //LOCAL WORKING
  //baseURL: "https://alinmauatapi.fajrbahrain.com/api/", //UAT WORKING,
  baseURL: url + "/api/",
  // headers: {
  //'X-user-Header-token': store.getters.GetToken
  // "Access-Control-Allow-Origin": "*"
  //}
});
var link = url == "https://alinmaapi.fajrbahrain.com" ? true : false;
Api.interceptors.response.use(
  (res) => {
    var { data } = res;
    if (data && data.StatusCode == 0) {
      store.dispatch(ACTIONS.LOGOUT_REQUEST, null);
    }
    if (data && data.RequestId != null && data.RequestId != "") {
      cm.setRefreshTokenCookie(data.RequestId);
    }
    return Promise.resolve(res);
  },
  (error) => {
    var { response } = error;
    if (response != null && response.status == 401) {
      store.dispatch(ACTIONS.LOGOUT_REQUEST, null);
    }
    return Promise.reject(error);
  },
);

export default Api;

export const LIVE = link;
